import {
  TableRow,
  TableCell,
  TextField,
  FormControl,
  NativeSelect,
} from "@mui/material";
import PropTypes from "prop-types";

const LookupTableRow = ({
  tableRowIndex,
  updateTableValues,
  data,
  permittedOutputs,
}) => {
  const changeValuesHandler = (e) => {
    const { value, name } = e.target;
    const cellIndex = +name.slice(5);
    const updatedRow = [...data];
    updatedRow[cellIndex] = value;
    updateTableValues(tableRowIndex, updatedRow);
  };

  const handleSelectChange = (e) => {
    const { value, name } = e.target;
    const cellIndex = +name.slice(5);
    const updatedRow = [...data];
    updatedRow[cellIndex] = value;
    updateTableValues(tableRowIndex, updatedRow);
  };

  return (
    <TableRow className="lookup-formula-table-row">
      {data.map((cellValue, index) => {
        const isLastColumn = index === data.length - 1;
        const hasPermittedOutputs = permittedOutputs.length > 0;

        if (hasPermittedOutputs && isLastColumn) {
          return (
            <TableCell key={`cell-${index}`}>
              <FormControl fullWidth>
                <NativeSelect
                  name={`field${index}`}
                  onChange={handleSelectChange}
                  value={cellValue || ""} // Use the mapped value directly
                >
                  <option value="">choose one:</option>
                  {permittedOutputs.map((option, i) => (
                    <option key={i} value={option}>
                      {option}
                    </option>
                  ))}
                </NativeSelect>
              </FormControl>
            </TableCell>
          );
        }

        return (
          <TableCell key={`cell-${index}`}>
            <TextField
              name={`field${index}`}
              variant="outlined"
              placeholder={!isLastColumn ? "<blank>" : "result"}
              value={cellValue || ""}
              onChange={changeValuesHandler}
              required
            />
          </TableCell>
        );
      })}
    </TableRow>
  );
};

LookupTableRow.propTypes = {
  row: PropTypes.number,
  sendDataToParent: PropTypes.func,
  data: PropTypes.array,
  permittedOutputs: PropTypes.array,
};

export default LookupTableRow;
